// extracted by mini-css-extract-plugin
export var background = "DownloadBambooApp-module--background--eb80a";
export var desktopContent = "DownloadBambooApp-module--desktopContent--55986";
export var downloadLinks = "DownloadBambooApp-module--downloadLinks--87cdc";
export var mobileContent = "DownloadBambooApp-module--mobileContent--8ebf3";
export var mobileTitle = "DownloadBambooApp-module--mobileTitle--0a36b";
export var qrCode = "DownloadBambooApp-module--qrCode--f36e6";
export var subtitle = "DownloadBambooApp-module--subtitle--bd900";
export var textContent = "DownloadBambooApp-module--textContent--81b26";
export var title = "DownloadBambooApp-module--title--96427";
export var wrapper = "DownloadBambooApp-module--wrapper--f8fc6";